// extracted by mini-css-extract-plugin
module.exports =  {"chartBlock":"chartBlock__BXTuZ","infoTip":"infoTip__JwPh0"};